/** A recognisable learner avatar for the family entry screens (D-16). */

const AVATAR_COLOURS = [
  'bg-sky-600',
  'bg-emerald-600',
  'bg-amber-600',
  'bg-fuchsia-600',
  'bg-rose-600',
  'bg-indigo-600',
] as const

/** Initial on a colour that stays the same for a learner across screens. */
export function LearnerAvatar({
  id,
  nickname,
  size = 'lg',
}: {
  id: string
  nickname: string
  size?: 'lg' | 'xl'
}): React.JSX.Element {
  let hash = 0
  for (const ch of id) hash = (hash * 31 + ch.charCodeAt(0)) >>> 0
  const colour = AVATAR_COLOURS[hash % AVATAR_COLOURS.length]
  const initial =
    nickname.trim().normalize('NFC').charAt(0).toLocaleUpperCase('vi') || '?'
  return (
    <span
      aria-hidden
      className={`flex shrink-0 items-center justify-center rounded-full font-bold text-white ${colour ?? ''} ${
        size === 'xl' ? 'size-24 text-5xl' : 'size-16 text-3xl'
      }`}
    >
      {initial}
    </span>
  )
}
